module.exports = __webpack_public_path__ + "img/klep-dark.3aec6bde.png";